export const subscriptionIdExceptions = {
    inviteExceptionIds: [2, 5, 8, 10, 11, 12, 13],
    workExceptionIds: [1, 4, 7, 22, 23],
  };  